import type { FC, PropsWithChildren } from "react";
import Icon from "../../../Icon";
import * as s from "./UspItem.module.scss";

const UspItem: FC<PropsWithChildren> = ({ children }) => {
	return (
		<li className={s.item}>
			<Icon icon="checkmark" className={s.icon} />
			<p>{children}</p>
		</li>
	);
};

export default UspItem;
